import React, { useEffect } from 'react';
import axios from 'axios';
import { Spin } from 'antd';
import { CalendarIcon } from '../../components/common/CustomIcon';
import Hero from './Hero';
import Layout from '../layout/Layout';
import './Fastrack.scss';
import withVetsmithService from '../Vetsmith/Vetsmith.service';
import FastrackCompleteCard from './FastrackCompleteCard';
import { VetsmithItem, getUncompletedStep } from '../Vetsmith/Vetsmith';
import { ApiConstant, PageConstant } from '../../../constants';
import jobsActions from '../jobs/jobs.actions';
import FastrackFailedCard from './FastrackFailedCard';
import { pushLog2DV2LogServer } from '../../../services/logging';
import { getUserObject } from '../../util/getUserFullName';
const Fastrack = ({
    infos,
    service,
    ldFlags,
    fastrack,
    store = {}
}) => {
    const { steps, flow } = infos;
    if (!steps || !fastrack || !flow) return null;
    const message_completion = flow.message_completion.length ? flow.message_completion : null;
    const message_completion_title = flow.message_completion_title.length  ? flow.message_completion_title : null;
    const {
        description = "",
    } = fastrack;

    useEffect(() => {
        const user = getUserObject();
        const {
            state: {
                redirectedFrom = null,
            } = {},
            pathname
        } = service.props.location;
        pushLog2DV2LogServer.info(
            'FASTTRACK',
            'PAGE_VIEW',
            { user_id: user.uid },
            { user_id: user.uid, fasttrack_id: fastrack.id, redirect_from: redirectedFrom, current_url: pathname }, null
        );
    }, [])

    const {
        dashboard: {
            availability: {
                last_update = null
            } = {},
        } = {}
    } = store;

    const failed = fastrack.status === "FAILED";
    const passed = fastrack.status === "PASSED";

    const LastAvailabilityUpdatedBadge =  () => (
        <span className="vetsmith-item-badge">
            <CalendarIcon/>
            Last update: {new Date(last_update).toLocaleDateString('en-US', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' })}
        </span>
    );
    return (
        <div className="fastrackHolder">
            <Hero
                title={fastrack.title}
                subtitle='Top U.S. tech companies are looking for developers just like you!'
            >
                <div className="fastTrackDescription" dangerouslySetInnerHTML={{ __html: description }} />
            </Hero>
            <Layout width={1200}>
                <div className="stepsHolder">
                    {failed && <FastrackFailedCard name={fastrack.title} infos={infos} service={service}/>}          
                    {passed && <FastrackCompleteCard infos={infos} service={service} title={message_completion_title} description={message_completion} />}
                    {infos.orderSteps.map((stepName, index) => <VetsmithItem
                        key={stepName}
                        badge={(stepName === 'availability' && last_update) ? <LastAvailabilityUpdatedBadge /> : null} 
                        item={infos.steps[stepName]}
                        showEstTime={stepName !== 'availability'}
                        service={service}
                        ldFlags={ldFlags}
                        subscribeCode={infos && infos.code ? infos.code : ''}
                        ribbon={false}
                    />)}
                </div>
            </Layout>
        </div>
    )
};


const withFastrackService = (WrappedComponent) => {
    return class extends React.Component {

        state = {
            fastrack: null,
            loading: false,
        };

        componentDidMount() {
            this.loadData();
        }

        componentDidUpdate(prevProps) {
            if (prevProps.store.jobs.fastrackLoading && !this.props.store.jobs.fastrackLoading) {
                this.loadData();
            }

            const prevFlow = prevProps.service.state.flow || {};
            const currentFlow = this.props.service.state.flow || {};

            const prevSteps = prevProps.infos.steps || {};
            const currentSteps = this.props.infos.steps || {};
            const prevStepKeys = Object.keys(prevSteps);
            if (
                prevFlow.id !== currentFlow.id || // Check if `id` has changed
                !prevStepKeys.every(key => {
                    const prevStep = prevSteps[key] || {};
                    const currentStep = currentSteps[key] || {};
                    return prevStep.status === currentStep.status;
                })
            ) {
                this.loadFastrackFlows();
            }
        }

        isFastrack = () => {
            return this.props.service.props.location.pathname.includes(PageConstant.FAST_TRACK_PAGE)
        }

        loadFastrackFlows = () => {
            this.props.service.props.dispatch(jobsActions.FETCH_FASTRACK_FLOWS);
        }

        getFastrackFlow = () => {
            const { id: fastTrackId = null } = this.props.match.params;
            this.setState({ loading: true });
            const fastTrack = (this.props.store.jobs.fastrack || []).find(({ id }) => id == fastTrackId);
            if (fastTrack) {
                this.setState({
                    fastrack: fastTrack,
                    loading: false
                });
                this.props.service.setState({
                    fastrack: fastTrack
                });
                return fastTrack;
            }
            return null;
        }

        subscribeToVetsmith = async (code) => {
            const token = localStorage.getItem('token');
            if (token) axios.defaults.headers.common.Authorization = token;
            return axios.post(ApiConstant.BASE_URL + 'vetsmith-subscribe', { code })
                .then((res) => res.data)
                .then((data) => {
                    console.log(data);
                    if (data.success) {
                        console.log('Subscription success');
                    }
                });
        }

        loadData = async () => {
            const fastrack = this.getFastrackFlow();
            if (!fastrack) return;
            const { flowId: fastrackVetsmithId, code }  = fastrack;
            if (this.isFastrack() && this.props.store.jobs.fastrackLoading) return;

            await this.subscribeToVetsmith(code);
            this.props.service.loadData(fastrackVetsmithId, true);
        }

        render() {
            if (this.props.store.jobs.loading || this.props.store.jobs.fastrackLoading || this.state.loading || !this.props.infos.flow) {
                return <Spin spinning />
            }

            return <WrappedComponent
                {...this.props}
                fastrack={this.state.fastrack}
            />;
        }
    };
}

export const hastFastrackFlow = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const redirectParam = queryParams.get('redirectBackToFastrack');

    return Boolean(redirectParam);
};

export const redirectToFastrack = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const redirectParam = queryParams.get('redirectBackToFastrack');

    if (redirectParam) {
        window.location.href  = `${PageConstant.FAST_TRACK_PAGE}/${redirectParam}`;
    }
};



export default withVetsmithService(withFastrackService(Fastrack), true);